module.exports = __webpack_public_path__ + "static/img/图@2x.3fb2f44.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/图@2x.webp
// module id = xfRr
// module chunks = 1